import * as React from "react";
import { TPublicationsReportApplicantPresentationModel } from "../../../../presenter/report/model/PublicationsReportApplicantPresentationModel";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";
import PublicationsReportPDFTemplate from "./PublicationsReportPDFTemplate";

const PublicationsReportPDFLink = ({
  translate,
  applicants,
  title,
  fileName
}: {
  translate: any;
  applicants: TPublicationsReportApplicantPresentationModel[];
  title: string;
  fileName: string;
}) => {
  return (
    <PDFDownloadLink
      document={
        <PublicationsReportPDFTemplate
          translate={translate}
          applicants={applicants}
          title={title}
        />
      }
      fileName={fileName}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          translate("reports.document.loading")
        ) : (
          <Icon
            type="file-pdf"
            theme={"outlined"}
            style={{ fontSize: 20, color: "#ED1C24" }}
          />
        )
      }
    </PDFDownloadLink>
  );
};

export default PublicationsReportPDFLink;
